import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44330d76"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "d-flex flex-column gap" }
const _hoisted_3 = ["src"]

import { onMounted } from "vue"
import { useI18n } from "vue-i18n"
import { useRouter } from "vue-router"


export default /*#__PURE__*/_defineComponent({
  __name: 'LocalePicker',
  setup(__props) {

const locales = [
  {
    name: "DE",
    img: require("@/assets/locales/de.png"),
    value: "de",
  },
  {
    name: "EN",
    img: require("@/assets/locales/en.png"),
    value: "en",
  },
]
const i18n = useI18n()

const $router = useRouter()

onMounted(() => {
  const locale = localStorage.getItem("locale")
  if (locale) {
    i18n.locale.value = locale
  }
})
const updateLocale = (locale: string): void => {
  localStorage.setItem("locale", locale)
  i18n.locale.value = locale
  window.dispatchEvent(new CustomEvent("locale-changed"))
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    "offset-y": "",
    "open-on-hover": "",
    "open-on-click": "",
    eager: ""
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps({ flat: "" }, props, { color: "#25344d" }), {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: require(`@/assets/locales/${_ctx.$i18n.locale}.png`)
          }, null, 8, _hoisted_1)
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(locales, (locale, index) => {
          return _createVNode(_component_v_btn, {
            key: index,
            onClick: ($event: any) => (updateLocale(locale.value))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: locale.img
              }, null, 8, _hoisted_3),
              _createTextVNode(" " + _toDisplayString(locale.name), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        }), 64))
      ])
    ]),
    _: 1
  }))
}
}

})